"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzCol__Wrapper",
  componentId: "sc-12nno1h-0"
})(["\n  grid-column: auto / span ", ";\n  max-width: 100%;\n\n  ", "\n/*\n  ", "\n*/\n\n  @media (min-width: 576px) {\n    ", "\n    /*\n    ", "\n    ", "\n    */\n  }\n\n  @media (min-width: 768px) {\n    ", "\n    /*\n    ", "\n    ", "\n    */\n  }\n\n  @media (min-width: 992px) {\n    ", "\n    /*\n    ", "\n    ", "\n    */\n  }\n\n  @media (min-width: 1200px) {\n    ", "\n    /*\n    ", "\n    ", "\n    */\n  }\n\n"], function (props) {
  return props.width;
}, function (props) {
  return props.order ? "\n    order: ".concat(function (props) {
    return props.order;
  }, ";\n  ") : null;
}, function (props) {
  return props.offset ? "\n    margin-left: ".concat(function (props) {
    return props.offset / 12 * 100;
  }, "%;\n  ") : null;
}, function (props) {
  return props.widthsm ? "\n      grid-column: auto / span " + props.widthsm + ";\n    " : null;
}, function (props) {
  return props.ordersm ? "\n      order: " + props.ordersm + ";\n    " : null;
}, function (props) {
  return props.offsetsm ? "\n      margin-left: " + props.offsetsm / 12 * 100 + "%;\n    " : null;
}, function (props) {
  return props.widthmd ? "\n      grid-column: auto / span " + props.widthmd + ";\n    " : null;
}, function (props) {
  return props.ordermd ? "\n      order: " + props.ordermd + ";\n    " : null;
}, function (props) {
  return props.offsetmd ? "\n      margin-left: " + props.offsetmd / 12 * 100 + "%;\n    " : null;
}, function (props) {
  return props.widthlg ? "\n      grid-column: auto / span " + props.widthlg + ";\n    " : null;
}, function (props) {
  return props.orderlg ? "\n      order: " + props.orderlg + ";\n    " : null;
}, function (props) {
  return props.offsetlg ? "\n      margin-left: " + props.offsetlg / 12 * 100 + "%;\n    " : null;
}, function (props) {
  return props.widthxl ? "\n      grid-column: auto / span " + props.widthxl + ";\n    " : null;
}, function (props) {
  return props.orderxl ? "\n      order: " + props.orderxl + ";\n    " : null;
}, function (props) {
  return props.offsetxl ? "\n      margin-left: " + props.offsetxl / 12 * 100 + "%;\n    " : null;
});

var OzCol = function OzCol(_ref) {
  var children = _ref.children,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 12 : _ref$width,
      widthsm = _ref.widthsm,
      widthmd = _ref.widthmd,
      widthlg = _ref.widthlg,
      widthxl = _ref.widthxl,
      order = _ref.order,
      ordersm = _ref.ordersm,
      ordermd = _ref.ordermd,
      orderlg = _ref.orderlg,
      orderxl = _ref.orderxl,
      offset = _ref.offset,
      offsetsm = _ref.offsetsm,
      offsetmd = _ref.offsetmd,
      offsetlg = _ref.offsetlg,
      offsetxl = _ref.offsetxl;
  return __jsx(Wrapper, {
    width: width,
    widthsm: widthsm,
    widthmd: widthmd,
    widthlg: widthlg,
    widthxl: widthxl,
    order: order,
    ordersm: ordersm,
    ordermd: ordermd,
    orderlg: orderlg,
    orderxl: orderxl,
    offset: offset,
    offsetsm: offsetsm,
    offsetmd: offsetmd,
    offsetlg: offsetlg,
    offsetxl: offsetxl
  }, children);
};

var _default = OzCol;
exports.default = _default;